
export const asegurarURL = function(medio, valor) {
	valor = (valor || '').trim()
	if (!medio || !valor) {
		return ''
	}

	let vm = valor.toLowerCase()
	if (vm.indexOf('https://') === 0 || vm.indexOf('http://') === 0) {
		return valor
	}

	if (medio === 'whatsapp') {
		return asegurarURLComprobandoPrefijos('wa.me/', 'https://wa.me/', valor)
	} else if (medio === 'instagram') {
		return asegurarURLComprobandoPrefijos('instagram.com/', 'https://www.instagram.com/', valor)
	} else if (medio === 'facebook') {
		return asegurarURLComprobandoPrefijos('facebook.com/', 'https://www.facebook.com/', valor)
	} else if (medio === 'twitter') {
		return asegurarURLComprobandoPrefijos('twitter.com/', 'https://twitter.com/', valor)
	} else if (medio === 'linkedin') {
		return asegurarURLComprobandoPrefijos('linkedin.com/', 'https://www.linkedin.com/', valor)
	} else if (medio === 'youtube') {
		return asegurarURLComprobandoPrefijos('youtube.com/', 'https://www.youtube.com/', valor)
	} else if (medio === 'númeroTelefónico') {
		valor = valor.replace(/(\s|\+|\-|\(|\))/g, '')
		return `tel:${valor}`
	} else if (medio === 'correoElectrónico') {
		valor = valor.toLowerCase()
		return `mailto:${valor}`
	}

	return ''
}

function asegurarURLComprobandoPrefijos(URLOpcnl, URLBase,  valor) {
	let vm = valor.toLowerCase()
	if (vm.indexOf(URLOpcnl) === 0 || vm.indexOf(`www.${URLOpcnl}`) === 0) {
		return `https://${valor}`
	}

	valor = valor.replace(/\/$/, '')

	if (URLBase === 'https://wa.me/') {
		valor = valor.replace(/(\s|\+|\-|\(|\))/g, '')
	}

	return `${URLBase}${valor}`
}
